import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from 'src/app/modules/components/login/login.component';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router, private dialog: MatDialog) {

  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):  boolean {
      if (this.auth.isLoggedIn) {
        let roles = next.data["roles"] as Array<string>;
        if (roles) {
          var match = this.auth.roleMatch(roles);
          if (match) return true;
          else {
            this.router.navigate(['/forbidden']);
            return false;
          }
        }
        else 
          return true;
      } else {
        this.reLogin();
        return false;
      }
  }
  async reLogin() {
    await this.router.navigate(['/']);
    this.openLogin();
  }
  openLogin() {
    let dialogRef = this.dialog.open(LoginComponent, {
      height: '500px',
      width: '600px',
    })
    this.router.events
    .subscribe(() => {
      dialogRef.close();
    })
  }
  
}
